import '../styles.css';

function Home(props) {
    return (
        <>
        <div className='project'> 
        PROJECT
        </div>
        <div className='ideas'>
        IDEAS
        </div>
        <div className='background'>
            <img src= "https://i.ibb.co/fQx7Qpr/shutterstock-1924269197.png" alt="backgroundimage" className='background-image'></img>
        </div>
        </>
    );
}

export default Home;